import React, { Component } from "react";
import { Redirect } from 'react-router'
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from '@material-ui/core/CircularProgress';
import overviewPageStyle from "assets/jss/material-dashboard-pro-react/views/overviewPageStyle";

// dotNetify
import dotnetify from 'dotnetify';

//Authorization
import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

export class Loading extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("Loading", this, {
            headers: { Authorization: "Bearer " + auth.getAccessToken() },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            LoadingSubscription: true,
        };
    }
    UNSAFE_componentWillMount() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    componentDidMount() {
    }
    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.ServerToken && !this.state.ServerToken) {
            window.sessionStorage.ServerToken = nextState.ServerToken;
        }
        if (nextState.EncryptedPassword && !this.state.EncryptedPassword) {
            if (this.hasLocalStorage() && localStorage.chRememberMe) {
                localStorage.chPassword = nextState.EncryptedPassword;
            }
        }
    }
    hasLocalStorage = function () {
        try {
            window.localStorage.setItem("__test", "data");
            window.localStorage.removeItem("__test");
        } catch (e) {
            return false;
        }
        return true;
    }

    render() {
        const { classes } = this.props;
        return (
            <div style={{ height: '100vh' }}>
                {this.state.GoToOverview && (<Redirect to='/overview' />)}
                {this.state.SetNewPassword && (<Redirect to='/set-new-password' />)}
                {this.state.LoadingSubscription && <CircularProgress size={48} className={classes.buttonProgress} />}
            </div>
        );
    }
}

Loading.propTypes = {
    classes: PropTypes.object.isRequired,
    onAuthenticated: PropTypes.func
};

export default withStyles(overviewPageStyle)(withAITracking(reactPlugin, Loading));
